// import React from 'react';
// import Header from './Header';
// import Sidebar from './Sidebar';
// import '../../Styles/main.css';

// const Layout = ({ children, onLogout }) => {
//   return (
//     <div className="layout">
//       <Sidebar onLogout={onLogout} />
//       <div className="main-content">
//         <Header />
//         <main className="content">
//           {children}
//         </main>
//       </div>
//     </div>
//   );
// };

// export default Layout;

// Component/Layout/Layout.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import '../../Styles/main.css';
import { useSelector } from 'react-redux';

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const { token, loginData } = useSelector(state => state.influencer);

  const isAuthenticated = () => {
    return !!token;
  };

  React.useEffect(() => {
    if (!isAuthenticated() && !window.location.pathname.includes('/login')) {
      navigate('/login');
    }
  }, [navigate]);

  return (
    <div className="layout">
      {isAuthenticated() && <Sidebar />}
           <div className="main-content">
         <Header />
         <main className="content">
           {children}
         </main>
       </div>
    </div>
  );
};

export default Layout;